import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "state/reducer/user";

export function RoleGuard({ allowedRoles, children }) {
  // const userRole = useSelector((state) => state.auth.user_role.role);
  const profile = useSelector(selectUser).getProfile;

  if (!allowedRoles.includes(profile?.data?.role?.code)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
